<template>
  <Modal
      :closeIcon="true"
      size="lg"
      @close="close()"
    >
      <div slot="body">
        <div class="p-3 sm:p-5">
          <h1 class="font-semibold mb-6 text-center text-2xl lg:text-3xl">
            Select new caterer
          </h1>

          <!-- Search caterer form -->
          <div class="text-center">
            <input
              v-model="location"
              class="w-full mr-2 h-16 sm:w-112 px-8 rounded-lg sm:rounded shadow-primary"
              placeholder="Enter Delivery Zip Code (Exa: 90210)"
              type="text"
            />
            <div class="flex justify-center flex-col-reverse sm:flex-row mt-3">
              <button
                class="btn btn-primary font-semibold rounded px-10 w-full sm:w-40 sm:flex-none"
                @click="newLocation = location"
              >
                <span v-if="!loading">Search</span>
                <Spinner v-if="loading" class="mx-auto" />
              </button>
            </div>
          </div>
          <!-- ### -->

          <OrderSearchCaterers
            :zip="zip"
            @cancel="close()"
            @select="submitNewCaterer"
          />
        </div>
      </div>

      <div slot="footer"></div>
    </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue'
import Api from '@/api/api_v1.0'
import OrderSearchCaterers from '@/components/order/OrderSearchCaterers.vue'
export default {
  components: {
    Modal,
    OrderSearchCaterers,
  },

  data () {
    return {
      loading                      : false,
      location                     : '',
      newLocation                  : '',
      progressCatererDetailsLoading: true,
      catererDetails               : false,
    }
  },

  mounted () {
    this.location = this.zip
  },

  computed: {
    order () {
      return this.$store.state.currentEditingOrder
    },

    zip () {
      return this.newLocation.length > 0
          ? this.newLocation
          : this.order.zipcode
    },
  },

  methods: {
    close() {
      this.$emit('close')
    },

    async submitNewCaterer (data) {
      await Api.setOrderCaterer(this.order.uuid, data.id)
      await Api.updateOrderDetails(this.order.uuid, { zipcode: data.zip })
      await this.$store.commit('setCurrentEditingOrderCaterer', data.id)
      this.init()
      this.$emit('changed')
      this.close()
    },
  }
}
</script>

<style>

</style>